import { updateObjectState } from '../../helpers';

export const updateValueFieldsReducer = ({ storeField, valueField }) => {
  return (state, payload) => {
    const result = Object.entries(payload).reduce(
      (acc, [name, value]) => {
        return updateObjectState({ name, payload: { [valueField]: value }, state: acc });
      },
      { ...state[storeField] }
    );

    return updateObjectState({ name: storeField, payload: result, state: structuredClone(state) });
  };
};
